import React, { useState } from 'react'
import './portfolio.css'
import { 
  Card, CardActionArea, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Grow, Icon, Paper, Tab, Tabs, TextField, Typography 
} from '@mui/material'
import ResumeData from '../../utils/ResumeData'
import ImageGallery from '../../components/ImageGallery/ImageGallery'

const Portfolio = () => {
  const [tabValue,setTabValue] = useState('All');
  const [projectDialog, setProjectDialog] = useState(false);
  return (
    <Grid container className='section padding_bottom padding_top'>
      <Grid item className='section_title margin_bottom' >
      <span></span>
        <h6 variant='h6' className='text'>Portfolio</h6>
      </Grid>
      <Grid item xs={12}>
        <Tabs 
          value={tabValue} 
          indicatorColor='primary' 
          className='customTabs' 
          onChange={(event, newValue) => setTabValue(newValue)}
          TabIndicatorProps={{style: {display: 'none'}}}
        >
          <Tab 
            label='All' 
            value='All' 
            className={tabValue === 'All'? 'customTabs_item active' : 'customTabs_item'}
            style={{color: tabValue === 'All' ? '#fff !important' : '#555'}}
            sx={{
              '&.active': {
                color: '#fff !important',
              },
              '&.active span': {
                color: '#fff !important',
              }
            }}
          />
          {[...new Set(ResumeData.projects.map(item => item.tag))].map(tag=>(
            <Tab 
              key={tag}
              label={tag} 
              value={tag} 
              className={tabValue === tag ? 'customTabs_item active' : 'customTabs_item'}
              style={{color: tabValue === tag ? '#fff !important' : '#555'}}
              sx={{
                '&.active': {
                  color: '#fff !important',
                },
                '&.active span': {
                  color: '#fff !important',
                }
              }}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
            {ResumeData.projects.map(project=>(
                <>
               
                {tabValue===project.tag || tabValue==='All'? 
                 <Grid item xs={12} sm={6} md={4}>
                <Grow in timeout={1000}>
                <Card className='customCard' onClick={() => setProjectDialog(project)}>  
                  <CardActionArea>
                    <CardMedia className='customCard_image' image={project.images[0]} title={project.title}/>
                    <CardContent>
                      <Typography variant='body2' className='customCard_title'>{project.title}</Typography>
                      <Typography variant='body2' className='customCard_description'>{project.caption}</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
                </Grow>
                </Grid> :null}
                </>
            ))}
        </Grid>
      </Grid>

      <Dialog open={projectDialog} onClose={() => {setProjectDialog(false)}} className='projectDialog' maxWidth={"lg"}fullWidth>
      <DialogTitle>
        {projectDialog.title}
      </DialogTitle>
      <DialogContent style={{height:"80vh"}}>
        {
          projectDialog.images && (
            <ImageGallery images={projectDialog.images}/>
          )
        }
        <Typography className='projectDialog_description'>{projectDialog.description}</Typography>
      </DialogContent>
      <DialogActions className='projectDialog_actions'>
        {projectDialog?.links?.map( link => (
          <a href={link.link} target='_blank' className='projectDialog_icon'>{link.icon}</a>
        ))}
      </DialogActions>
    </Dialog>
    </Grid>
  )
}

export default Portfolio